import { Edit } from '@mui/icons-material'
import { Button, Card, CardContent, CircularProgress, Grid, Typography, Divider } from '@mui/material'
import { ExplanationAccordion, LabelField } from 'components'
import * as controllers from 'controllers'
import { CompanyBuyerCompanyDto, CompanyDto } from 'dtos'
import { enqueueSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import BuyerCompanyAddEditDialog from './BuyerCompanyAddEditDialog'
import { useAuth } from 'context'

interface BuyerCompanyAddEditDialogProps {
  company: CompanyDto
}

export default function BuyerCompanyListCard({ company }: BuyerCompanyAddEditDialogProps) {
  const { permissions } = useAuth()

  const [isBuyerCompanySaving, setIsBuyerCompanySaving] = useState<boolean>(false)
  const [buyerCompanyAddEditDialogOpen, setBuyerCompanyAddEditDialogOpen] = useState<boolean>(false)
  const [companyBuyerCompany, setCompanyBuyerCompany] = useState<CompanyBuyerCompanyDto>(new CompanyBuyerCompanyDto())
  const [isGettingBuyerCompany, setIsGettingBuyerCompany] = useState<boolean>(false)

  useEffect(() => {
    if (company.companyGuid) {
      setIsGettingBuyerCompany(true)
      controllers
        .getCompanyBuyerInformation(company.companyGuid)
        .then(response => {
          setCompanyBuyerCompany(response.value)
        })
        .finally(() => {
          setIsGettingBuyerCompany(false)
        })
    }
  }, [company])

  return (
    <>
      {permissions.COMPANIES_AND_PEOPLE_ADD_EDIT && (
        <BuyerCompanyAddEditDialog
          initialValues={companyBuyerCompany}
          loading={isBuyerCompanySaving}
          onClose={() => {
            setBuyerCompanyAddEditDialogOpen(false)
          }}
          onSave={values => {
            setIsBuyerCompanySaving(true)
            controllers
              .updateCompanyBuyerCompanyInformation(company.companyGuid!, values)
              .then(response => {
                enqueueSnackbar('Buyer Company Information Saved Successfully!', { variant: 'success' })
                setCompanyBuyerCompany(response.value)
                setBuyerCompanyAddEditDialogOpen(false)
              })
              .finally(() => {
                setIsBuyerCompanySaving(false)
              })
          }}
          open={buyerCompanyAddEditDialogOpen}
        />
      )}

      <Card>
        <CardContent>
          <Grid container spacing={1} alignItems='flex-start'>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={12} sm='auto'>
                <Typography fontWeight='bold' variant='h5'>
                  Buyer Company
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto'>
                {permissions.COMPANIES_AND_PEOPLE_ADD_EDIT && (
                  <Button
                    endIcon={<Edit />}
                    onClick={() => {
                      setIsBuyerCompanySaving(false)
                      setBuyerCompanyAddEditDialogOpen(true)
                    }}
                    variant='text'
                  >
                    EDIT
                  </Button>
                )}
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            {isGettingBuyerCompany && (
              <Grid item container alignItems='center' justifyContent='center' sx={{ my: 1 }}>
                <Grid>
                  <CircularProgress color='primary' size={50} />
                </Grid>
              </Grid>
            )}

            {!isGettingBuyerCompany && (
              <>
                <Grid item xs={12}>
                  <LabelField label='Buyer Code' value={companyBuyerCompany.buyerCode} />
                </Grid>

                {/* <Grid item xs={12}>
                  <LabelField label='Dealer #' value={companyBuyerCompany.dealerNumber} />
                </Grid>

                <Grid item xs={12}>
                  <LabelField label='IRS #' value={companyBuyerCompany.irsNumber} />
                </Grid> */}
              </>
            )}

            <Grid item xs={12}>
              <ExplanationAccordion variant='outlined'>
                ||This card only shows if the company is marked as a Buyer Company. ||
              </ExplanationAccordion>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
